<script>
    import {CHECKIN_STATUS} from "../lib/constants.js";
    import {createEventDispatcher} from 'svelte/internal';
    import CalendarControl from "../components/controls/CalendarControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import CheckinPerson from "./CheckinPerson.svelte";

    export let checkin = null;

    let initialized = false;

    const dispatch = createEventDispatcher();

    // const initialize = () => {
    //     checkin.persons.map(item => {
    //         item.address += (item.address ? ", " : "") + item.zip + (item.city ? " " + item.city : "");
    //     });
    //     initialized = true;
    // }

    const onDateChange = () => {
        dispatch("change", checkin);
    }

    // $: if (checkin && !initialized) {
    //     initialize();
    // }
</script>

<!--{#if initialized}-->
    <div class="panel-simple panel-pad mb-4">
        <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-4 col-6">
                <label>Check in</label>
                <CalendarControl bind:date="{ checkin.date_in }" on:change={ onDateChange } hideClear required/>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-4 col-6">
                <label>Check out</label>
                <CalendarControl bind:date="{ checkin.date_out }" on:change={ onDateChange } hideToday hideClear openRight required/>
            </div>
        </div>
    </div>

    {#if checkin.status_id == CHECKIN_STATUS.CONFIRMED}
        <div class="alert alert-info alert-with-icon mb-4">
            <div class="alert-icon">
                <AppIcon icon="check" strokeWidth="2" size="24"/>
            </div>
            This check in has been confirmed!
        </div>
    {:else if checkin.status_id == CHECKIN_STATUS.REFUSED}
        <div class="alert alert-danger alert-with-icon mb-4">
            <div class="alert-icon">
                <AppIcon icon="x" strokeWidth="2" size="24"/>
            </div>
            This check in has been rejected!
        </div>
    {/if}

    {#each checkin.persons as person, index}
        <CheckinPerson {person} {index} />
    {/each}
<!--{/if}-->